import { render, staticRenderFns } from "./RiskSkeleton.html?vue&type=template&id=0bdde5dc&external"
import script from "./RiskSkeleton.vue?vue&type=script&lang=js"
export * from "./RiskSkeleton.vue?vue&type=script&lang=js"
import style0 from "./RiskSkeleton.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports